const enforceTypeFacets = (results) => {
    results.facets.__type = {
        attachment_image: -1,
        post_gallery: -1,
        post_video: -1,
    }

    return results;
}

export {enforceTypeFacets}